
/* ************************************************************
GENERIC SKU-BUILDER FUNCTIONS
************************************************************ */

function SKUrule(target_option, partsArr){
  this.parts = partsArr;  if (target_option == 'mountSKUs' ) { window.target_option = target_option; window.partsArr = partsArr; window.arr1 = []; }
  this.SKUpart_lookup = {};
  this.constants = [];
  this.choices = [];
  this.calculation_inputs = [];
  this.target_option = this.name = target_option;

  for(var a=0; a<partsArr.length; a++){
    var part = partsArr[a];
    if(typeof part === 'string'){
      this.constants.push(part);
    } else if(part.name && part.codes){
      this.choices.push(this.SKUpart_lookup[part.name] = this.parts[a] = new SKUpart(part, this));  if (target_option == 'mountSKUs' ) {window.arr1.push(this.SKUpart_lookup[part.name]);}
      if(part.input_name){
        this.calculation_inputs.push(part.calculation_input = new BOLD.calculated_options.CalcField(part.input_name, part.id, part.name));
      }
    } else {
      console.warn('SKU RULES: To specify a rule, please include a name and an object named codes in the format of {abbreviation:value}');
    }
  }

  if(this.calculation_inputs.length && this.target_option){
    this.calculation = new BOLD.calculated_options.Calculation({
      inputs: this.calculation_inputs,
      target_name: this.target_option,
      formula: this.buildSkuFromOptions.bind(this)
    });
  }

  return this;
}

function SKUpart(partObj, SKUrule){
  this.SKUrule = SKUrule;
  this.codes = partObj.codes;
  this.name = partObj.name;
  this.input_name = partObj.input_name;
  this.using = partObj.using || null;
  this.optional = partObj.optional;
  this.false_positive_correction = partObj.false_positive_correction;
  this.can_disable_choices = partObj.can_disable_choices || false;


  if(!this.using){
    //The easy case
    this.abbreviations = [];
    this.values = [];

    for(var key in this.codes){
      var value = this.codes[key];
      this.addValue(key, value);
    }

  } else {
    //Woooo. Complex logic ahoy.
    this.abbreviations = {};
    this.values = {};
    this.namespaces = {};
    for(var namespace in this.codes){
      this.namespaces[namespace] = this.codes[namespace];
      this.abbreviations[namespace] = [];
      this.values[namespace] = [];
      for(var key in this.namespaces[namespace]){
        var value = this.namespaces[namespace][key];
        this.addValue(key, value, namespace);
      }
    }
    this.prereq_part = this.SKUrule.SKUpart_lookup[this.using];

    this.prereq_part.dependants = this.prereq_part.dependants || [];
    this.prereq_part.dependants.push(this);
  }

  return this;
}


SKUpart.prototype = {
  getAbbreviation:function(value, namespace){

    if(this.using){
      if(this.SKUrule.current_values || namespace){
        var namespace_value = namespace || (this.SKUrule.current_values[this.using] || {}).abbreviation;
        if(!namespace_value || !this.value_map[namespace_value]){
          return undefined;
        }
        return this.value_map[namespace_value][value]  || this.value_map[namespace_value].default;
      } else {
        return undefined;
      }
    }
    return this.value_map[value] || this.value_map.default;
  },
  getValue:function(abbreviation, namespace){
    var value;
    if(this.using){
      if(this.SKUrule.current_values || namespace){
        var namespace_value = namespace || this.SKUrule.current_values[this.using];
        value = this.codes[namespace_value] && this.codes[namespace_value][abbreviation];
      } else {
        return undefined;
      }
    } else {
      value = this.codes[abbreviation];
    }
    return value;
  },
  addValue:function(abbreviation, value, namespace){
    var value_map = (this.value_map = this.value_map || {});

    if(namespace){
      this.abbreviations[namespace] = this.abbreviations[namespace] || [];
      this.abbreviations[namespace].push(abbreviation);

      this.values[namespace] = this.values[namespace] || [];
      this.values.all = this.values.all || [];
      value_map[namespace] = value_map[namespace] || {};

    } else {
      this.abbreviations.push(abbreviation);
      valuesArr = this.values;
    }

    if(typeof value === 'object' && value.length){
      for(var i=0; i<value.length; i++){
        if(namespace){
          this.values.all.indexOf(value[i]) === -1 && this.values.all.push(value[i]);
          this.values[namespace].push(value[i]);
          value_map[namespace][value[i]] = abbreviation;
        } else {
          this.values.push(value[i]);
          value_map[value[i]] = abbreviation;
        }
      }
    } else {
      if(namespace){
        this.values.all.indexOf(value) === -1 && this.values.all.push(value);
        this.values[namespace].push(value);
        value_map[namespace][value] = abbreviation;
      } else {
        this.values.push(value);
        value_map[value] = abbreviation;
      }
    }
  },
  matches:function(selection){

  }
};

SKUrule.prototype = {
  assembleSku:function(values, save_values, keys_to_skip){
    var assembledSKU = '';
    var abbreviations = {};
    for(var p=0; p<this.parts.length; p++){
      var part = this.parts[p];
      if(keys_to_skip && keys_to_skip.indexOf(part.name) > -1){
        continue;
      }
      assembledSKU += (typeof part === 'string' ? part : (abbreviations[part.name] = part.getAbbreviation(values[part.name], abbreviations[part.using])) || '');
    }
    save_values && (this.current_values = this.decomposeSku(assembledSKU));
    return assembledSKU;
  },
  assembleMultipleSkus:function(values_original, save_values){
    var skuArr = [];
    var arrayOptions = [];
    var arrayLengths = [];
    var optionalKeys = [];

    var values = JSON.parse(JSON.stringify(values_original))

    for(var key in values){
      if(this.SKUpart_lookup[key].optional ){
        values[key] = [undefined].concat(values[key])
      }
      if(Array.isArray(values[key])){
        arrayOptions.push(key);
        arrayLengths.push(values[key].length);
      }
    }
    var index = 0;
    var valuesCopy = JSON.parse(JSON.stringify(values))
    var currentValueIndices;

    while( currentValueIndices = decrementIndexArray(arrayLengths, index)){
      for(var a=0; a<arrayOptions.length; a++){
        var key = arrayOptions[a];
        var value = values[key][currentValueIndices[a]]
        valuesCopy[key] = value;
      }
      skuArr.push(this.assembleSku(valuesCopy, save_values))

      index++;
    }
    return skuArr;
  },
  decomposeSku:function(sku, namespace){
    this.sku_lookup = this.sku_lookup || {};
    if(this.sku_lookup[sku]){
      return this.sku_lookup[sku];
    }

    var selections = {};
    var decomposingSku = sku;

    var dbg = false;
    //if (sku == 'P40HUH-BMS') dbg = true; 
    //if (sku == 'H30HUP-WA7') dbg = true; 
    //if (sku == 'P40HUP-BMS') dbg = true; 
    if (sku == 'G40BA-X-BF') dbg = true;
    if (sku == 'G40B-Z-BCN') dbg = true; 
    if (sku == 'G40--BF') dbg = true;
    
    if (window.dbgit == undefined) window.dbgit = [];

    if (dbg) dbgit.push(sku);
    if (dbg) dbgit.push(namespace);
    if (dbg) {
      for(var x = 0; x<this.parts.length; x++){  
        window.dbgit.push(this.parts[x]);
      }
    }
    
    for(var p = 0; p<this.parts.length; p++){
      var part = this.parts[p];
      if (dbg) window.dbgit.push("1A. decomposingSku="+decomposingSku);
      if (dbg) window.dbgit.push(decomposingSku);
      if(typeof part === 'string'){
        if(part === '?'){
          //Single-character wildcard
          decomposingSku = decomposingSku.replace(decomposingSku[0], '')
          if (dbg) window.dbgit.push("1B. decomposingSku="+decomposingSku);
          continue;
        }
        else if(decomposingSku.indexOf(part) !==0 ){
          console.error( 'SKU Error: Invalid SKU in ' + this.name + '!  Expecting ' + part + ', found ' + decomposingSku.substr(0, part.length) + ' in ' + sku);
          //We've determined it's invalid, remove it from our all_possible_combinations list
          return false;
        }
        console.error();
        if (dbg) window.dbgit.push("2. decomposingSku="+decomposingSku);
        decomposingSku = decomposingSku.replace(part, '');
        if (dbg) window.dbgit.push("3. decomposingSku="+decomposingSku);
      } else {
        // Assume that the longest-matching part is the one to use
        var longestMatch = 0;
        var selection = null;
        var abbreviationsArr;

        if(part.using){
          namespace = namespace || (selections[part.using] ||{}).abbreviation;
          abbreviationsArr = part.abbreviations[namespace] || [];
        } else {
          namespace = null;
          abbreviationsArr = part.abbreviations;
        }


        for(var a=0; a<abbreviationsArr.length; a++){
          var abbr = abbreviationsArr[a];
          if(abbr.length < longestMatch){
            continue;
          }
          if(decomposingSku.indexOf(abbr) === 0){
            selection = abbr;
            longestMatch = abbr.length;
          }
        }

        /* If the current part is optional, check the next part's abbreviations to see if there's a better match */
        if(part.optional && part.false_positive_correction && this.parts[p+1] && this.parts[p+1].abbreviations){
          var matches_next = false;
          var next_part = this.parts[p+1]
          var nextArr = next_part.abbreviations;
          for(var a=0; a<nextArr.length; a++){
            var abbr = nextArr[a];
            if(abbr.length < longestMatch){
              continue;
            }
            if(decomposingSku.indexOf(abbr) === 0){
              matches_next = true;
              break
            }
          }
          if(matches_next){
            continue;
          }
        }

        selections[part.name] = {abbreviation: selection, value: part.getValue(selection, namespace), SKUpart:part };
        if(namespace){
          selections[part.name].namespace = namespace;
        }
        if(selection !== null){
          decomposingSku = decomposingSku.replace(selection, '');
        }
      }
    }
    return (this.sku_lookup[sku] = selections);
  },
  countDegreesOfSeparation:function(sku, selectionsObj){
    var namespace;
    for(var key in selectionsObj){
      namespace = namespace || selectionsObj[key].namespace;
    }
    var decomposedSkuObj = (typeof sku === 'string' ? this.decomposeSku(sku, namespace) : sku);
    var degrees_of_separation = 0;
    for(var key in decomposedSkuObj){
    //If nothing selected for this field, skip it-  anything goes
    var selection = selectionsObj[key];
    if(selection.value === null || selection.value === undefined){
      continue;
    }

    var feature = decomposedSkuObj[key];
    var partObj = this.SKUpart_lookup[key];

    if(partObj.using){
      if(!selectionsObj[partObj.using]){
        //If the condtion part hasn't been selected yet, we don't care and can move on
        continue;
      }
        //If we've got a namespaced situation... uh-oh
        var conditionPart = this.SKUpart_lookup[partObj.using];
        // for(var a=0; a<conditionPart.abbreviations.length; a++){

          var namespace = decomposedSkuObj[partObj.using].abbreviation;

          if(selection.value && namespace && partObj.value_map[namespace] && typeof partObj.value_map[namespace][selection.value] !== 'string'){
            degrees_of_separation += 2;
          }
        // }


      } else {
        //If the abbreviations don't match, increment degrees of separation
        feature.abbreviation !== selectionsObj[key].abbreviation && degrees_of_separation ++;
      }
    }
    return degrees_of_separation;
  },
  setPossibleCombinations:function(skuARR){
    return (this.all_possible_combinations = skuARR);
  },
  setOption:function(option, alias){
    if(!option || !option.DOM || !option.DOM.element || !alias){
      return;
    }
    var optionElement = option.DOM.element;
    var fields = optionElement.querySelectorAll('option,input');
    var optionType = option.type;

    this.options = this.options || {};
    this.options[alias || option.internalName] = {
      option: option,
      type: option.type,
      fields: fields
    };
  },
  checkPossibleFutureChoices:function(selections){
    if(!this.all_possible_combinations){
      throw 'SKU Error: No SKUs set yet - please run setPossibleCombinations(skuArray) first to set the complete list';
    }
    var permitted_choices = {};
    for(var c=0; c<this.choices.length; c++){
      var choice = this.choices[c];
      var name = choice.name;
      permitted_choices[name] = [];


      //If this option doesn't disable any of the choices, allow everything
      if(!choice.can_disable_choices){
        permitted_choices[name] = choice.values.all || choice.values;
        continue;
      }

      //Otherwise, for each value at this decision juncture, is there an existing SKU that can fill in the gap?
      //all_values depends on whether the SKU contributions have a condition or not
      var all_values = choice.values.all || choice.values;

      //Loop through all the values, then find existing SKUs matching those values...
      for(var v=0; v<all_values.length; v++){
        var value = all_values[v];
        for(var s=0; s<this.all_possible_combinations.length; s++){
          var sku = this.all_possible_combinations[s];

          var sku_is_compatible = this.areSelectionsCompatible(selections, sku, name, value);
          if(sku_is_compatible){
            permitted_choices[name].push(value);
            break;
          }
        }
      }

    }
    return permitted_choices;
  },
  areSelectionsCompatible:function(selections, sku, field_name, value){
    var modified_selections = JSON.parse(JSON.stringify(selections));
    modified_selections[field_name] = value;
    var sku_breakdown = this.decomposeSku(sku);
    if(!sku_breakdown){
      return false;
    }
    for(var key in sku_breakdown){
      var sku_value = sku_breakdown[key].value;
      if(!Array.isArray(sku_value)){
        sku_value = [sku_value];
      }
      /* If this part is optional and we only have [undefined] for possible sku values, skip to the next */
      if(this.SKUpart_lookup[key].optional && sku_value.length === 1 && !sku_value[0]){
        continue;
      }
      /* If it's selected but doesn't appear in the SKU value array, return false */
      if(modified_selections[key] && (sku_value.indexOf(modified_selections[key]) === -1)){
        return false;
      }
    }
    return true;
  },
  parseSelections:function(selections){
      parsedSelections = {};
      var allOptions = this.SKUpart_lookup;
      for(var key in allOptions){
        var part = this.SKUpart_lookup[key];
        var value = selections[key];
        parsedSelections[key] = { SKUpart:part, value:value, abbreviation:part.getAbbreviation(value, selections[part.using]) }
      }
      return parsedSelections;
  },
  filterChoices:function(selections){
    if(!this.all_possible_combinations){
      console.error( 'SKU Error: No SKUs set yet - please run setPossibleCombinations(skuArray) first to set the complete list');
      return;
    }
    return this.filtered_choices = this.all_possible_combinations.reduce(function(summary, sku){
            //Anything that requires 2 or more changes is too far removed to be available with a single selection change
            if(this.countDegreesOfSeparation(sku, selections) <= 1){
              //Any values associated with this SKU that we haven't already saved get added to our available choices object
              var obj = this.decomposeSku(sku);
              for(var key in obj){
                summary[key] = summary[key] || [];
                !(summary[key].filter(function(value){ return value.abbreviation == obj[key].abbreviation}).length) && summary[key].push(obj[key]);
              }
            } else {

            }
            return summary;
          }.bind(this), {});
  },
  triggerChangeEvent:function(element){
    this.debounce_ids = this.debounce_ids || {};
    element.debounce_id = element.debounce_id || Date.now();

    if(this.debounce_ids[element.debounce_id]){
      clearTimeout(this.debounce_ids[element.debounce_id]);
    }

    this.debounce_ids[element.debounce_id] = setTimeout(function(){
      element.dispatchEvent(BOLD.helpers.createEvent('change'));
    }, 100)

  },
  filterOptions:function(selections){
    //We're gonna need to merge data from multiple skubuilds...
    if(!this.options){
      throw 'SKU Error: No options set - please run setOption(option, alias) first to set the option elements that need to be filtered.'
    }
    filtered_choices = this.checkPossibleFutureChoices(selections) //(typeof parsedSelections == 'object' ?  this.filterChoices(parsedSelections) : this.filtered_choices);

    var value_lookup = filtered_choices;
    for(var opt in this.options){
      this.applyOptionLockout(opt, value_lookup);
    }
  },
  filterMultipleOptions:function(selections){
    //We're gonna need to merge data from multiple skubuilds...
    if(!this.options){
      throw 'SKU Error: No options set - please run setOption(option, alias) first to set the option elements that need to be filtered.'
    }


    var choices = [];
    var arrayOptions = [];
    var arrayLengths = [];

    for(var key in selections){
      if(Array.isArray(selections[key])){
        arrayOptions.push(key);
        arrayLengths.push(selections[key].length);
      }
    }
    var index = 0;
    var selectionsCopy = JSON.parse(JSON.stringify(selections))
    var currentValueIndices;

    while( currentValueIndices = decrementIndexArray(arrayLengths, index)){
      for(var a=0; a<arrayOptions.length; a++){
        var key = arrayOptions[a];
        var value = selections[key][currentValueIndices[a]]
        selectionsCopy[key] = value;
      }
      var value_lookup = this.checkPossibleFutureChoices(selectionsCopy)

      for(var opt in this.options){
        this.applyOptionLockout(opt, value_lookup);
      }

      index++;
    }

  },
  applyOptionLockout:function(opt, value_lookup){
    /* If this option can't disable choices, skip it! */
    if(!this.SKUpart_lookup[opt].can_disable_choices){
      return;
    }
    var elements = this.options[opt].fields;

    for(var e=0; e< elements.length; e++){
      var element = elements[e]
      if(element.type === 'hidden' || !element.value){
        continue;
      }
      element.lockbox = element.lockbox || {};
      element.lockbox[this.name] = (value_lookup[opt].indexOf(element.value) === -1);

      var isDisabled = false;
      for(var key in element.lockbox){
        isDisabled = isDisabled || element.lockbox[key] || false;
      }
      element.disabled = isDisabled;
      if(element.nodeName === 'INPUT'){
        var wrapper = element.closest('.bold_option_value')
        if(wrapper){
          var was_hidden = wrapper.style.display == 'none';
          wrapper.style.display = (isDisabled ? 'none' : '')
          if(was_hidden != isDisabled){
            BOLD.helpers.triggerEvent('BMS.SkuBuilder.option_visibility_changed', {element:element})
          }
        }

      }
      this.clearDisabledSelections(element);

      var type = this.options[opt].type;
      this.toggleSwatchElements(element, type);
    }
    // Try to make disabled options hidden on Safari, as Safari doesn't respect display:none
    if(this.checkIfBrowserIsSafari()){
      this.hideElementsOnSafari();
    }
  },
  checkIfBrowserIsSafari:function(){
    //Because Safari doesn't respect display:none on <option> elements
    if(typeof this.isSafari === 'undefined'){
      this.isSafari = (typeof safari !== 'undefined' || navigator.platform === 'iPhone' || navigator.platform === 'iPod' || navigator.platform === 'iPad')
    }
    return this.isSafari;
  },
  hideElementsOnSafari:function(){
    //Safari doesn't respect display:none on option elements. Hacky workaround is to make them display:none by wrapping them with a hidden <span>
    if(window.jQuery){
      jQuery('span>option').unwrap();
      jQuery('option[disabled]').wrap('<span style="display:none"></span>');
    }
  },
  clearDisabledSelections:function(element){
    var selectbox = element.tagName === 'OPTION' ? element.closest('select') : null;
    if(selectbox && selectbox.selectedIndex === 0){
      selectbox.selectedIndex = 1
      element = selectbox[1]
      this.triggerChangeEvent(selectbox)
    }
    if(element && element.disabled && (element.selected || element.checked)){
      element.selected = element.checked = false;
      if(element.tagName.toLowerCase() === 'option'){
        var selectbox = element.closest('select');
        for(var o=1; o<selectbox.options.length; o++){
          var option_element = selectbox.options[o];
          if(option_element.value && !option_element.disabled){
            selectbox.selectedIndex = o;
            this.triggerChangeEvent(selectbox);
            break;
          }
        }

      } else {
        this.triggerChangeEvent(element);
      }
    }
  },
  toggleSwatchElements:function(element, type){
    if(type==='swatch'){
      var swatch_wrapper = element.closest('.bold_option_value');
      swatch_wrapper.setAttribute('data-disabled', element.disabled);
    }
  },
  buildSkuFromOptions:function(inputs, target_option, option_product, calcObj){
    if(!target_option){
      return null
    }
    this.saveOptions(option_product, target_option);

    var isMulti = target_option.type.indexOf('multi') > -1;
    if(isMulti){
      return this.buildSkuMulti(inputs, target_option, option_product, calcObj);
    } else {
      return this.buildSkuSingle(inputs, target_option, option_product, calcObj);
    }
  },
  buildSkuSingle:function(inputs, target_option, option_product, calcObj){
    var sku = this.assembleSku(inputs, true);
    this.filterOptions(inputs)
    return this.filterWildCards(sku);
  },
  buildSkuMulti:function(inputs, target_option, option_product, calcObj){
    var skus = this.assembleMultipleSkus(inputs, true);

    this.filterMultipleOptions(inputs)
    return this.filterWildCardsMulti(skus);
  },
  filterWildCards:function(sku){
    if(sku.indexOf('?') === -1){
      return sku;
    }
    //Shortcut: assume for now that there's a single wildcard
    var wildIndex = sku.indexOf('?');
    for(var s=0; s<this.all_possible_combinations.length; s++){
      var skuMatch = this.all_possible_combinations[s];
      skuCheck = sku.replace('?',skuMatch[wildIndex]);
      if(skuCheck === skuMatch){
        return skuMatch
      }
    }
    return skuCheck
  },
  filterWildCardsMulti:function(skus){
    for(var s=0; s<skus.length; s++){
      skus[s] = this.filterWildCards(skus[s])
    }
    return skus;
  },
  saveOptions:function(option_product, target_option){
    this.option_product = this.option_product || option_product;
    if(!this.options){
      for(var c=0; c<this.choices.length; c++){
        var choice = this.choices[c];
        this.setOption(BOLD.calculated_options.getOptionByInternalName(this.option_product, choice.input_name), choice.name);
      }
    }
    if(target_option && !this.all_possible_combinations){
      var potential_values = target_option.optionValues;
      var potential_skus_array = [];
      for(var s=0; s<potential_values.length; s++){
        this.decomposeSku(potential_values[s].name) && potential_skus_array.push(potential_values[s].name);
      }
      this.setPossibleCombinations(potential_skus_array);
    }
  }
}

function decrementIndexArray(array_of_index_lengths, n){
  //Takes an array of integers representing array lengths and returns an array of indices corresponding to that position
  //Returns null if either input is invalid or if n is greater than the total number of values
  //Examples: [10, 10] - 0  = [9, 9]
  //          [10, 10] - 1  = [9, 8]
  //          [10, 10] - 10 = [8, 9]
  //          [10, 10] - 100= [0, 0]
  //          [10, 10] - 101= null
  //          [10, 2]  - 2  = [8, 1]
  //          [10, 2]  - 5  = [7, 0]
  if(typeof n!== 'number' || n < 0){
    //Abort if we don't have a positive number supplied
    return null;
  }
  var result = [];
  for(var i=array_of_index_lengths.length-1; i>=0; i--){
    var len = array_of_index_lengths[i];
    if(typeof len !== 'number'){
      //Abort if anything in our array of lengths is not a number
      return null;
    }
    result[i] = (result[i] || 0) + len - (n % len) - 1;
    n = Math.floor(n/len);
    if(result[i] < 0){
      //'Borrow' 1 from the next-highest position
      result[i] = result[i] + array_of_index_lengths[i];
      result[i-1] = -1;
    }
  }

  return n > 0 || result.length === 0 ? null : result;
}

BOLD.common.eventEmitter.on('BMS.SkuBuilder.option_visibility_changed', function(evt){
  var wrapper = evt.data.element.closest('.bold_option');
  if(!wrapper){ return }

  var available_selections = wrapper.querySelectorAll('input[type="checkbox"]:not([disabled])')
  wrapper.style.display = (available_selections.length > 0 ? '' : 'none')
})

/* Special case: Can have only one of front-mount branding graphic or back-mount branding graphic
                 Can also have only one of Faceplate (Full) and Faceplate (Logo)
*/
BOLD.options.app.on('option_changed', function(evt){
  var option = evt.data.option;
  if(option.internalName !== 'brandingPosition' || !evt.data.source_input.checked){
    return;
  }
  var elements = option.DOM.element.querySelectorAll('option,input');
  var source_value = evt.data.source_input.value;
  var disableBackdrop, disableFloorFront, disableFaceplateLogo, disableFaceplateFull;
  if(source_value.indexOf('Backdrop') > -1){
    disableFloorFront = true;
  }
  else if(source_value.indexOf('Floor Front') > -1){
    disableBackdrop = true;
  }

  if(source_value.indexOf('Full Faceplate') > -1){
    disableFaceplateLogo = true
  } else if (source_value.indexOf('Logo') > -1){
    disableFaceplateFull = true;
  }

  var values = option.getValueArray();
  var needs_update = false;
  for(var e=0; e<elements.length; e++){
    var element = elements[e];
    if(element.value.indexOf('Backdrop')>-1){
      // element.lockbox = element.lockbox || {};
      // element.lockbox.brandingOverride = disableBackdrop || false;
      if(disableBackdrop && element.checked){
        element.checked = false;
        values.indexOf(element.value) > -1 && values.splice(values.indexOf(element.value),1)
        needs_update = true
      }
    }
    else if(element.value == 'Floor Front'){
      // element.lockbox = element.lockbox || {};
      // element.lockbox.brandingOverride = disableFloorFront;
      if(disableFloorFront && element.checked){
        element.checked = false;
        values.indexOf(element.value) > -1 && values.splice(values.indexOf(element.value),1)
        needs_update = true
      }
    } else if(element.value === 'Full Faceplate'){
      if(disableFaceplateFull && element.checked){
        element.checked = false;
        values.indexOf(element.value) > -1 && values.splice(values.indexOf(element.value),1)
        needs_update = true
      }
    }
    else if(element.value.indexOf('Logo') > -1){
      if(disableFaceplateLogo && element.checked){
        element.checked = false;
        values.indexOf(element.value) > -1 && values.splice(values.indexOf(element.value),1)
        needs_update = true
      }
    }
  }
  if(needs_update){
    setTimeout(function(){option.receiveValue(values)}, 10);
  }

})

BOLD.helpers.createEvent = function(eventName, options){
  if(typeof(Event) === 'function') {
    return new Event(eventName, options || { view: window, bubbles: true, cancelable: true });
  }else{
    var event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
    return event
  }
}

//Polyfill for element.closest
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector ||
                              Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}
